import { render, staticRenderFns } from "./person-withdrawal-record.vue?vue&type=template&id=706628a2&scoped=true"
import script from "./person-withdrawal-record.vue?vue&type=script&lang=js"
export * from "./person-withdrawal-record.vue?vue&type=script&lang=js"
import style0 from "./person-withdrawal-record.vue?vue&type=style&index=0&id=706628a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706628a2",
  null
  
)

export default component.exports